import React from 'react'
import { Button, ListItem, IconButton, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getSessionId } from '@fs/zion-session'
import { ContentDownload, ContentDelete } from '@fs/zion-icon'
import { useGenealogyTreesContext } from '../GenealogyTreesProvider'
import { disabledStatuses } from '../../../helpers'

export default function CompareAction({ type, tree, enableDisabled, flexBox }) {
  const [t] = useTranslation()
  const { handleCompare, isDeleting } = useGenealogyTreesContext()
  const { communityTree, id, treeStatus, treeUri } = tree
  const isInCompleteState = treeStatus?.includes('COMPLETE')

  const disabled = disabledStatuses.includes(tree.treeStatus) || isDeleting
  const ActionComponent = type === 'button' ? Button : ListItem

  const RowComp = flexBox ? Row : React.Fragment
  const flexBoxProps = flexBox ? { gutters: 'none' } : {}
  const listItemCompareProps = type === 'button' ? {} : { primaryText: t('tree-import.actions.compare') }
  const listItemViewProps = type === 'button' ? {} : { primaryText: t('tree-import.actions.view') }
  return (
    <RowComp {...flexBoxProps}>
      {!communityTree && !isInCompleteState && (
        <ActionComponent
          disabled={enableDisabled && disabled}
          data-testid="row-compare-button"
          onClick={() => handleCompare(treeUri)}
          {...listItemCompareProps}
        >
          {t('tree-import.actions.compare')}
        </ActionComponent>
      )}
      {!communityTree && isInCompleteState && (
        <ActionComponent
          disabled={enableDisabled && disabled}
          data-testid="row-view-button"
          to={disabled ? undefined : `/compare/${id}`}
          linkName="Upload Row: View"
          {...listItemViewProps}
        >
          {t('tree-import.actions.view')}
        </ActionComponent>
      )}
    </RowComp>
  )
}

export function OtherActions({ type, tree, onDeleteClick, flexBox }) {
  const [t] = useTranslation()
  const { downloadUri, treeStatus } = tree
  const { isDeleting } = useGenealogyTreesContext()

  const ActionComponent = type === 'button' ? IconButton : ListItem
  const disabled = disabledStatuses.includes(treeStatus) || isDeleting

  const RowComp = flexBox ? Row : React.Fragment
  const flexBoxProps = flexBox ? { gutters: 'md' } : {}
  const listItemDownloadProps =
    type === 'button' ? { Icon: ContentDownload } : { primaryText: t('tree-import.actions.download') }
  const listItemDeleteProps =
    type === 'button' ? { Icon: ContentDelete } : { primaryText: t('common-ui:delete.action') }
  return (
    <RowComp {...flexBoxProps}>
      <ActionComponent
        disabled={disabled || !downloadUri}
        data-testid="row-download-button"
        title={t('tree-import.actions.download')}
        to={
          disabled || !downloadUri
            ? undefined
            : `${downloadUri.replace('http://', 'https://')}?sessionId=${getSessionId()}`
        }
        linkName="Upload Row: Download"
        {...listItemDownloadProps}
      />
      <ActionComponent
        disabled={disabled}
        data-testid="row-delete-button"
        title={t('common-ui:delete.action')}
        linkName="Upload Row: Delete"
        onClick={onDeleteClick}
        {...listItemDeleteProps}
      />
    </RowComp>
  )
}
